var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterinline = function SvgFilterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9,
    cy: 4.7,
    r: 1.6,
    stroke: "#21201F",
    transform: "rotate(180 11.9 4.7)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    d: "M9.2 4.9H2M2.5 11.3a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0ZM14 11.5H6.8"
  })));
};
export default SvgFilterinline;